import React from "react";
import { StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionHeading } from "@/components/sections/SectionHeading";
import { PRICING } from "@/data/content";
import { Check } from "lucide-react";
import { GoldButton, GhostButton } from "@/components/GoldButton";
import { useWaitlist } from "@/context/WaitlistContext";

export const Pricing = () => {
  const { openWaitlist } = useWaitlist();
  return (
    <section id="pricing" data-testid="pricing" className="relative bg-gradient-to-b from-ivory to-ivory-light py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          align="center"
          overline="Pricing"
          title="Choose your golden tier"
          accentWord="golden tier"
          subtitle="Start free, go global, or scale gold rewards for your business. No lock-ins, cancel anytime."
        />

        <StaggerGroup className="mt-16 grid gap-6 lg:grid-cols-4" stagger={0.08}>
          {PRICING.map((tier, i) => (
            <StaggerItem key={tier.name}>
              <div
                data-testid={`pricing-tier-${i}`}
                className={`relative flex h-full flex-col rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1.5 ${
                  tier.highlight
                    ? "border-2 border-gold bg-gradient-to-b from-white to-gold-rose/10 shadow-[0_20px_60px_-15px_rgba(212,175,55,0.4)]"
                    : "glass-card"
                }`}
              >
                {tier.highlight && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-gradient-to-r from-gold to-gold-amber px-4 py-1 text-xs font-semibold text-charcoal-deep shadow-lg">
                    Most popular
                  </span>
                )}
                <h3 className="font-serif text-2xl font-normal text-charcoal">{tier.name}</h3>
                <div className="mt-3 flex items-baseline gap-1">
                  <span className="font-serif text-4xl text-charcoal">{tier.price}</span>
                  <span className="text-sm text-charcoal-soft">{tier.cadence}</span>
                </div>
                <ul className="mt-6 flex-1 space-y-3">
                  {tier.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-charcoal-soft">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={2.4} />
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-7">
                  {tier.highlight ? (
                    <GoldButton data-testid={`pricing-cta-${i}`} className="w-full" onClick={() => openWaitlist("pricing")}>
                      {tier.cta}
                    </GoldButton>
                  ) : (
                    <GhostButton data-testid={`pricing-cta-${i}`} className="w-full justify-center" onClick={() => openWaitlist("pricing")}>
                      {tier.cta}
                    </GhostButton>
                  )}
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
